export function getQueryString(name) {
    let url = window.location.href
    var query = url.substring(url.indexOf('?') + 1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] === name){return pair[1];}
    }
    return(false);
}

export function validatePhone (val) {
    if (/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(val)) {
        return true
    } else {
        return false
    }
}